<template>
    <div class="detail">
    </div>
</template>
<script >

const {mapState} = require('vuex')
export default {
  components: {},
  data () {
    return {
      activeName: '',
      row: {}
    }
  },
  computed: {
    ...mapState({
      showDetail: (state) => {
        return state.home.showDetail
      }
    })
  },
  created () {
    this.row = this.showDetail
    this.activeName = this.showDetail.activeName
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.detail{
  padding: 40px;
  .head{
    font-size: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.close{
        display: flex;
        box-sizing: content-box;
        padding: 5px;
        height: 24px;
        cursor: pointer;
        width: 87px;
    height: 30px;
    font-size: 20px;
    cursor: pointer;
        img{
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
      }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/details/index.vue